<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit expense</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save">Update</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.name" label="Name" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.price"
                label="Price"
                prepend-icon="euro_symbol"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                >

                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    label="Date"
                    v-model="dateFormatted"
                    prepend-icon="event"
                    readonly
                    :rules="itemRules"
                    required
                  ></v-text-field>
                </template>
                  <v-date-picker v-model="form.date" no-title scrollable
                  @input="dateFormatted = formatDate($event)"
                  @change="menu=false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <m-upload-expense item-id="form.id" @uploaded="onUploaded"></m-upload-expense>
              <v-flex xs12>
                <v-text-field v-model="form.description" label="Description" required :rules="itemRules"></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
  import FormMixin from '@/mixins/formvalid';
  import MUploader from '@/components/uploader/uploader';
  export default {
    mixins: [FormMixin],
    props: ['dialog', 'expense', 'form'],
    components: {
      'm-upload-expense': MUploader
    },
    data () {
      return {
        valid: false,
        menu: false,
        date: null,
        dateFormatted: null,
        items: []
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      unformatDate (date) {
        if (!date) {
          return null
        }
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
      },
      onUploaded (data) {
        console.log('onUploaded', data);
        if (data.imageUrl) {
          this.form.imageUrl = data.imageUrl;
          this.form.contentType = data.contentType;
          this.form.itemKey = data.id;
        }
      },
      save () {
        if (this.$refs.form.validate()) {
          this.$emit('update', this.form);
        }
      },
      close () {
        this.$emit('close');
      },
      prefill (d) {
        for (var key in d) {
          this.form[key] = d[key]; // copies each property to the form object
        }
        this.form.date = this.unformatDate(this.expense.date);
        this.dateFormatted = this.expense.date;
      },
      init (v) {
        if (v) {
          console.log('Edit: do init:', this.expense);
          this.prefill(this.expense);
        }
      }
    },
    watch: {
      dialog (value) {
        this.init(value);
      }
    }
  }
</script>

